import { useTranslation } from 'react-i18next';
import { LinkButton } from '../../../../app/components/AppButton';
import { useAppSelector } from '../../../../app/store/hooks';
import { paths, rolePath } from '../../../../app/routes/paths';
import { useAppRole } from '../../../../app/routes/useRolePath';
import { formatMajorAmount } from '../../application/formatLessonMoney';
import { useGetMyLessonOfferingsQuery } from '../../infrastructure/api/lessonOfferings.api';
import '../pages/lessons.scss';

type Props = {
  variant: 'dashboard' | 'profile';
};

export function MyLessonsPanel({ variant }: Props) {
  const { t, i18n } = useTranslation();
  const role = useAppRole();
  const accessToken = useAppSelector((state) => state.authorization.accessToken);
  const { data: offerings = [] } = useGetMyLessonOfferingsQuery(undefined, {
    skip: !accessToken,
  });
  const listHref = rolePath(role, paths.lessons);
  const createHref = rolePath(role, paths.lessonCreate);
  const activeCount = offerings.filter((offering) => offering.status === 'published').length;

  if (variant === 'profile') {
    return (
      <div className="mentor-lessons mentor-lessons--compact">
        <p className="mentor-lessons__muted">
          {t('lesson.active_count', { count: activeCount })}
        </p>
        <LinkButton to={listHref} variant="primary">
          {t('lesson.manage_lessons')}
        </LinkButton>
      </div>
    );
  }

  return (
    <section className="mentor-lessons mentor-lessons--card">
      <h2>{t('lesson.my_lessons')}</h2>
      {offerings.length === 0 ? (
        <>
          <p>{t('lesson.empty_title')}</p>
          <p className="mentor-lessons__muted">{t('lesson.empty_body')}</p>
          <LinkButton to={createHref} variant="primary">
            {t('lesson.create_lesson')}
          </LinkButton>
        </>
      ) : (
        <>
          <ul className="mentor-lessons__rows">
            {offerings.slice(0, 2).map((offering) => (
              <li key={offering.id}>
                <span>{offering.title}</span>
                <span>
                  {formatMajorAmount(offering.price, offering.currency, i18n.language, 0)}
                  {' / '}
                  {offering.durationMinutes} {t('mentor-profile.price_minutes')}
                </span>
              </li>
            ))}
          </ul>
          <p className="mentor-lessons__muted">
            {t('lesson.active_count', { count: activeCount })}
          </p>
          <LinkButton to={listHref} variant="primary">
            {t('lesson.manage_lessons')}
          </LinkButton>
        </>
      )}
    </section>
  );
}
